import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotesStore } from '../store';
import { Star, Calendar, Folder, Tag } from 'lucide-react';

export default function TableView() {
  const navigate = useNavigate();
  const { notes, toggleStar } = useNotesStore();

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b text-left text-muted-foreground">
            <th className="pb-2 font-medium w-8"></th>
            <th className="pb-2 font-medium">Title</th>
            <th className="pb-2 font-medium">Folder</th>
            <th className="pb-2 font-medium">Tags</th>
            <th className="pb-2 font-medium">Updated</th>
          </tr>
        </thead>
        <tbody>
          {notes.map(note => (
            <tr
              key={note.id}
              className="border-b hover:bg-muted/50 cursor-pointer transition-colors"
              onClick={() => navigate(`/note/${note.id}`)}
            >
              <td className="py-2">
                <button
                  onClick={(e) => { e.stopPropagation(); toggleStar(note.id); }}
                  className={`p-1 rounded hover:bg-muted ${note.starred ? 'text-yellow-500' : 'text-muted-foreground'}`}
                >
                  <Star size={14} fill={note.starred ? 'currentColor' : 'none'} />
                </button>
              </td>
              <td className="py-2 font-medium">{note.title}</td>
              <td className="py-2 text-muted-foreground">
                <span className="flex items-center gap-1"><Folder size={12} /> {note.folder}</span>
              </td>
              <td className="py-2">
                <div className="flex gap-1 flex-wrap">
                  {note.tags?.slice(0, 3).map(t => (
                    <span key={t} className="text-xs px-1.5 py-0.5 bg-secondary rounded">{t}</span>
                  ))}
                </div>
              </td>
              <td className="py-2 text-muted-foreground text-xs">
                {new Date(note.updated_at).toLocaleDateString()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
